import { useDispatch } from 'react-redux';
import { redirect } from 'redux-first-router';

import { useMount } from '@simplywallst/ui-core';

import { usePortfolios } from '@/hooks/portfolio/usePortfolio';

import {
  ROUTE_PORTFOLIO,
  ROUTE_DEPRECATED_PORTFOLIO_LIST,
} from '@/constants/routes';

const Redirect = ({ to }: { to: Parameters<typeof redirect>[0] }) => {
  const dispatch = useDispatch();

  useMount(() => {
    dispatch(redirect(to));
  });

  return null;
};

export const DefaultPortfolio = () => {
  const { data: portfolios = [], isFetching } = usePortfolios();
  const [firstPortfolio = null] = [...portfolios].sort(
    (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
  );

  if (isFetching) {
    return null;
  }

  if (firstPortfolio) {
    return (
      <Redirect
        to={{
          type: ROUTE_PORTFOLIO,
          payload: { portfolioId: firstPortfolio.id },
        }}
      />
    );
  }

  return <Redirect to={{ type: ROUTE_DEPRECATED_PORTFOLIO_LIST }} />;
};
